import { styled } from '@mui/material/styles';

export const EventWrapper = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
